import { useKaannos } from '../lib/i18n';
import { useBranding } from '../lib/queries';
import { useRatkaistuTeema } from '../lib/teema';

/**
 * Yrityksen tunnus (suunnitelma 7).
 *
 * Versio valitaan **ratkaistun** teeman mukaan eikä valitun: `jarjestelma`
 * on kolmas vaihtoehto vain valinnassa, tausta on aina joko vaalea tai
 * tumma.
 *
 * Osoitteessa on versiotunniste, jotta vaihdettu tunnus näkyy heti eikä
 * vasta seuraavalla kovalla latauksella. Pelkkä `no-cache` riittää
 * palvelimen puolella, mutta selain ei lataa jo piirrettyä `<img>`-elementtiä
 * uudelleen ilman että sen `src` muuttuu.
 *
 * Tunniste kattaa molemmat versiot, ei vain piirrettävää: kun asennuksella
 * on vain toinen oma tunnus, palvelin tarjoilee sitä myös toiselle
 * taustalle — ja silloin senkin vaihdon pitää näkyä täällä.
 */
export default function Logo({ className }: { className?: string }) {
  const teema = useRatkaistuTeema();
  const { data } = useBranding();
  const { t } = useKaannos();

  const versio = data
    ? [data.logos.vaalea?.updatedAt ?? 'oletus', data.logos.tumma?.updatedAt ?? 'oletus'].join('_')
    : null;

  const osoite = `/api/branding/logo?variant=${teema}${versio ? `&v=${encodeURIComponent(versio)}` : ''}`;

  return (
    <img
      src={osoite}
      // Nimi kertoo mikä tunnus on kyseessä; ennen kuin se on haettu,
      // yleisnimitys on parempi kuin tyhjä alt (joka tarkoittaa
      // ruudunlukijalle "koriste, ohita").
      alt={data?.brandName ?? t('tunnus.logoAlt')}
      className={className}
    />
  );
}
